import {
  addDays,
  endOfDay,
  format,
  isAfter,
  isBefore,
  parseISO,
  startOfDay,
  subDays,
} from 'date-fns'

import { IEvent } from 'types'

import { TransformedEvent } from './types'

const dateFormat = 'yyyy-MM-dd'

export const generateDateParams = (end: Date, daysWithoutEnd = 9) => {
  const startTime = subDays(end, daysWithoutEnd)

  return {
    startTime: startOfDay(startTime).toISOString(),
    endTime: endOfDay(end).toISOString(),
  }
}

// Разбиваем каждое событие на фрагменты по дням и группируем
export const transformDurationEvents = (events: IEvent[]): Record<string, TransformedEvent[]> => {
  const groupedEvents: Record<string, TransformedEvent[]> = {}

  events.forEach((event) => {
    if (!event.startTime || !event.endTime) return

    const start = parseISO(event.startTime)
    const end = parseISO(event.endTime)

    if (isAfter(start, end)) return

    let currentDayStart = startOfDay(start)
    const lastDayStart = startOfDay(end)

    while (currentDayStart <= lastDayStart) {
      const currentDayEnd = endOfDay(currentDayStart)
      const fragmentStart = isAfter(start, currentDayStart) ? start : currentDayStart
      const fragmentEnd = isBefore(end, currentDayEnd) ? end : currentDayEnd

      if (isAfter(fragmentStart, fragmentEnd)) {
        currentDayStart = addDays(currentDayStart, 1)
        continue
      }

      const dayKey = format(currentDayStart, dateFormat)

      if (!groupedEvents[dayKey]) {
        groupedEvents[dayKey] = []
      }

      groupedEvents[dayKey].push({
        ...event,
        fragmentStart,
        fragmentEnd,
      })

      currentDayStart = addDays(currentDayStart, 1)
    }
  })

  return groupedEvents
}

export const transformOneTimeEvents = (events: IEvent[]): IEvent[] =>
  events
    .filter((event) => event.startTime && !event.endTime)
    .sort((a, b) => {
      const startA = parseISO(a.startTime)
      const startB = parseISO(b.startTime)
      return startA.getTime() - startB.getTime()
    })
